export const SELECT_ORG = "SELECT_ORG";
export const SELECT_OWNER = "SELECT_OWNER";
export const RESET_OWNERS_STATE = "RESET_OWNERS_STATE";

export const selectOrg = (orgID) => ({
  type: SELECT_ORG,
  payload: {
    orgID,
  },
});

export const selectOwner = ({ id, name }) => ({
  type: SELECT_OWNER,
  payload: {
    id,
    name,
  },
});

export const resetOwnersState = () => ({
  type: RESET_OWNERS_STATE,
});
